import { useEffect } from 'react'

import { Chats } from '../../firebase/collections'

const useChatListenerAssignedConv = ({
  selectedBuilding,
  dispatchAddAssignedConversationIds,
  dispatchRemoveAssignedConversationIds,
}) => {
  const buildingIdNumber =
    selectedBuilding && typeof selectedBuilding === 'object'
      ? selectedBuilding.id
      : selectedBuilding

  useEffect(() => {
    if (buildingIdNumber) {
      const unsubscribeAssignedListener = Chats.doc(`${buildingIdNumber}`)
        .collection('channelsWithLastMessage')
        .onSnapshot((snapshot) => {
          snapshot.docChanges().forEach((change) => {
            const channelChanged = change.doc.data()
            if (change.type === 'added' || change.type === 'modified') {
              if (channelChanged.assignee) {
                dispatchAddAssignedConversationIds(change.doc.id, channelChanged.assignee)
              }
            }
            if (change.type === 'modified' && !channelChanged.assignee) {
              dispatchRemoveAssignedConversationIds(change.doc.id)
            }
          })
        })

      return () => {
        unsubscribeAssignedListener()
      }
    }
  }, [buildingIdNumber])
}

export default useChatListenerAssignedConv
